import { ApiResponse } from '@restaurant/types';
import httpClient from '~/http';

export type CategoryItem = {
  id: string;
  name: string;
};

export type OrderTypeItem = {
  id: string;
  orderType: string;
};

export const fetchOrderTypes = () => {
  return httpClient.get<
    ApiResponse<{
      orderTypes: OrderTypeItem[];
    }>
  >('/api/v1/orderType');
};

export const fetchCategory = () => {
  return httpClient.get<ApiResponse<CategoryItem[]>>('/api/v1/category');
};
